const wrapper = "_uxswwkmsvf";
const heading = "_uxsh1ll7e2b";
const answer = "_uxsa1216419";

export { answer, heading, wrapper };
import "./atom.input.style.linaria.module.css";
//# sourceMappingURL=atom.input.style.js.map
